(function () {
    $('select[name="age"], select[name="passengers"], select[name="country_of_residence"]').selectize({
        selectOnTab: true,
        create: false,
    });
})();
